import React from 'react';
import { Cell, Pie, ResponsiveContainer, PieChart as PieChartComp } from 'recharts';
import { RADIAL_BAR_FILLS } from 'src/features/home/types';

type Props = {
    dataKey: string;
    data?: { [key: string]: string | number }[];
    children?: React.ReactNode;
};

export default function PieChart({ dataKey, data, children }: Props) {
    return (
        <div className="relative flex-1">
            <ResponsiveContainer>
                <PieChartComp>
                    <Pie
                        data={data}
                        dataKey={dataKey}
                        cx="50%"
                        cy="50%"
                        innerRadius="70%"
                        outerRadius="100%"
                        isAnimationActive
                    >
                        {data?.map((_, i) => (
                            <Cell key={i} fill={RADIAL_BAR_FILLS[i % RADIAL_BAR_FILLS.length]} />
                        ))}
                    </Pie>
                </PieChartComp>
            </ResponsiveContainer>
            {children && <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{children}</div>}
        </div>
    );
}
